import { formatScore } from "@/lib/score";

const SIZES = {
  small: { dimension: 52, stroke: 5, text: "text-sm" },
  default: { dimension: 64, stroke: 6, text: "text-base" },
  large: { dimension: 104, stroke: 8, text: "text-2xl" },
};

function toneClass(score) {
  if (score >= 8) return "score-tone-high";
  if (score >= 5) return "score-tone-mid";
  if (score >= 3) return "score-tone-low";
  return "score-tone-poor";
}

export const ScoreRing = ({ score = 0, size = "default" }) => {
  const normalized =
    Math.round(Math.max(0, Math.min(10, Number(score) || 0)) * 10) / 10;
  const { dimension, stroke, text } = SIZES[size] || SIZES.default;
  const radius = (dimension - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (normalized / 10) * circumference;

  return (
    <div
      className={`relative inline-grid place-items-center ${toneClass(normalized)}`}
      style={{ width: dimension, height: dimension }}
    >
      <svg
        width={dimension}
        height={dimension}
        role="img"
        aria-label={`Arvosana ${formatScore(normalized)}/10`}
      >
        <circle
          className="score-ring-bg"
          cx={dimension / 2}
          cy={dimension / 2}
          r={radius}
          fill="none"
          strokeWidth={stroke}
        />
        <circle
          className="score-ring-progress"
          cx={dimension / 2}
          cy={dimension / 2}
          r={radius}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${dimension / 2} ${dimension / 2})`}
        />
      </svg>
      <span className={`absolute font-heading font-bold ${text}`}>
        {formatScore(normalized)}
      </span>
    </div>
  );
};
